module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"passReset":"Reset password","email":"E-mail","sendEmail":"Send e-mail","registration":"Registration","login":"Login","recoveryInfoSent":"Password recovery information was sent to your e-mail address."}}')
  delete Component.options._Ctor
}
